import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import {
  useAddCompanyWarehousesMutation,
  useDeleteCompanyWarehousesMutation,
  useEditCompanyWarehousesMutation
} from "../../../../redux/api/chemicalization/companyWarehousesApi";
import { EntCompanyWarehouses } from "../../../../models/chemicalization/companyWarehouses";
import { getCookie } from "typescript-cookie";


const useCompanyWarehouses = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [ addCompanyWarehouses ] = useAddCompanyWarehousesMutation();
  const [ deleteCompanyWarehouses ] = useDeleteCompanyWarehousesMutation();
  const [ editCompanyWarehouses ] = useEditCompanyWarehousesMutation();

  async function onAddCompanyWarehouses(newCompanyWarehouses: EntCompanyWarehouses): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addCompanyWarehouses(newCompanyWarehouses).then((response: any) => {
		 if (response.error) {
									 const isKyrgyz = getCookie('i18next') === 'ky';
									 const lang = isKyrgyz ? 'kg' : 'ru';
									 const res = response.error.data?.res;
									 const errorMessages = Array.isArray(res)
										 ? res.map((error: any) => error[lang] || error.ru).join('\n')
										 : response.error.data?.msg || t('unknownError'); 
									 throw new Error(errorMessages);
								 }
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeleteCompanyWarehouses(companyWarehouses: EntCompanyWarehouses) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteCompanyWarehouses(companyWarehouses.id as number).then((response: any) => {
			 if (response.error) {
										 const isKyrgyz = getCookie('i18next') === 'ky';
										 const lang = isKyrgyz ? 'kg' : 'ru';
										 const res = response.error.data?.res;
										 const errorMessages = Array.isArray(res)
											 ? res.map((error: any) => error[lang] || error.ru).join('\n')
											 : response.error.data?.msg || t('unknownError'); 
										 throw new Error(errorMessages);
									 }
			if (response.data.success) {
			  status = true;
			  Modal.success({ title: t('msg.successDelete') });
			  if (refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  }

  async function onEditCompanyWarehouses(editedCompanyWarehouses: EntCompanyWarehouses): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editCompanyWarehouses(editedCompanyWarehouses).then((response: any) => {
		if (response.error) {
			const isKyrgyz = getCookie('i18next') === 'ky';
			const lang = isKyrgyz ? 'kg' : 'ru';
			const res = response.error.data?.res;
			const errorMessages = Array.isArray(res)
				? res.map((error: any) => error[lang] || error.ru).join('\n')
				: response.error.data?.msg || t('unknownError'); 
			throw new Error(errorMessages);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({ title: t('msg.successEdited') });
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  }

  return { onAddCompanyWarehouses, onDeleteCompanyWarehouses, onEditCompanyWarehouses };

}
export { useCompanyWarehouses };

